import { Tooltip } from '@cian/ui-kit/tooltip';

import { FC } from 'react';

import styles from './FeatureLabel.css';

export type FeatureLabelTooltipPlacement = `bottom${'-start' | '-end' | ''}`;

type FeatureLabelProps = {
  icon: JSX.Element;
  title: string;
  /**
   * @default {bottom}
   */
  placement?: `bottom${'-start' | '-end' | ''}`;
  dataTestId?: string;
};

export const FeatureLabel: FC<FeatureLabelProps> = props => {
  const { icon, title, placement = 'bottom', dataTestId } = props;

  return (
    <Tooltip placement={placement} portal={false} title={title}>
      <div className={styles['label']} data-testid={dataTestId}>
        {icon}
      </div>
    </Tooltip>
  );
};
